// extracted by mini-css-extract-plugin
export default {"form-input":"FormInput_form-input__UQyaC","message-error":"FormInput_message-error__GOWg1"};